// removed by extract-text-webpack-plugin
module.exports = {"featured":"P2u8","featured-content":"pUyl","featured-more":"_1SDn","featured-title":"tE1s","featured-description":"_1Z0o","close-notification":"_2DjR","notificationOpen":"_3YWg","dropdownOpen":"y6Uj","theme-light":"_1ymv","featured-icon":"m6uH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FeaturedHead/FeaturedHead.styl
// module id = 77
// module chunks = 0